<template>
  <div class="fsp" :class="{ 'fsp--dark': item.headerStyle === 'dark' }">
    <div class="fsp-header">
      <div>
        <div class="fsp-label">{{ $t('feed.adLabel') }}</div>
        <div class="fsp-name">{{ item.sponsorName }}</div>
        <div v-if="item.description" class="fsp-desc">{{ item.description }}</div>
      </div>
      <div class="fsp-actions">
        <f7-button v-if="item.ctaLabel" class="fsp-cta" fill small @click="$emit('cta', item)">{{ item.ctaLabel }}</f7-button>
        <f7-link class="fsp-hide" @click="$emit('hide', item)">{{ $t('feed.hide') }}</f7-link>
      </div>
    </div>

    <div v-if="item.stats" class="fsp-stats">
      <div v-for="stat in item.stats" :key="stat.label" class="fsp-stat">
        <div class="fsp-stat-value" :class="{ 'fsp-stat-value--accent': stat.accent }">{{ stat.value }}</div>
        <div class="fsp-stat-label">{{ stat.label }}</div>
      </div>
      <f7-link v-if="item.learnMoreLabel" class="fsp-learn" @click="$emit('learnMore', item)">
        {{ item.learnMoreLabel }}
      </f7-link>
    </div>
  </div>
</template>

<script setup>
import i18n from '../../js/i18n.js'

defineProps({
  item: { type: Object, required: true },
})
defineEmits(['cta', 'hide', 'learnMore'])

const { t } = i18n.global
</script>

<style scoped>
.fsp {
  border-radius: 25px;
  border: 0.5px solid var(--avocash-gold, #C9A84C);
  overflow: hidden;
  margin-bottom: 8px;
  content-visibility: auto;
  contain-intrinsic-size: 160px;
}
.fsp--dark .fsp-header,
.fsp-header {
  background: var(--avocash-gold-light, #FDF6E3);
  padding: 10px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.fsp-label {
  font-size: 9px;
  color: #92400E;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
  font-weight: 600;
}
.fsp-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--f7-text-color, #000);
}
.fsp-desc {
  font-size: 11px;
  color: var(--f7-on-surface-variant, #6d6d72);
  margin-top: 2px;
}
.fsp--dark .fsp-label { color: #92400E; }
.fsp--dark .fsp-name { font-size: 12px; color: var(--f7-text-color, #000); }
.fsp--dark .fsp-desc { color: var(--f7-on-surface-variant, #6d6d72); font-size: 11px; }
.fsp-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  flex-shrink: 0;
}
.fsp-cta {
  --f7-button-bg-color: var(--avocash-gold, #C9A84C);
  --f7-button-text-color: #412402;
  --f7-button-border-radius: 25px;
  --f7-button-font-size: 11px;
  --f7-button-font-weight: 500;
}
.fsp-hide {
  font-size: 9px;
  color: var(--f7-on-surface-variant, #8e8e93);
  --f7-link-highlight-opacity: 0;
}
.fsp--dark .fsp-hide { color: var(--f7-on-surface-variant, #8e8e93); }
.fsp-stats {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 10px 12px;
  background: var(--f7-page-bg-color, #fff);
}
.fsp-stat { text-align: center; }
.fsp-stat-value {
  font-size: 15px;
  font-weight: 500;
}
.fsp-stat-value--accent { color: var(--avocash-green, #1A6B42); }
.fsp-stat-label {
  font-size: 10px;
  color: var(--f7-on-surface-variant, #8e8e93);
}
.fsp-learn {
  margin-left: auto;
  font-size: 11px;
  color: var(--f7-on-surface-variant, #6d6d72);
  --f7-link-highlight-opacity: 0;
}
</style>
